if (!customElements.get('bs-planes')) customElements.define('bs-planes', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.tabs = [...this.querySelectorAll('[data-bs-plan-tab]')];
    this.panels = [...this.querySelectorAll('[data-bs-plan-panel]')];
    this.selector = this.querySelector('[data-bs-selector]');
    this.media = matchMedia('(max-width: 749px)');
    this.index = Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
    if (this.tabs.length > 1) {
      this.selector.hidden = false;
      this.setAttribute('data-bs-mejorado', '');
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-bs-plan-tab]');
        if (tab) this.select(Number(tab.dataset.bsPlanTab));
      }, { signal });
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-bs-plan-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = this.tabs.indexOf(tab);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((item, index) => item.tabIndex = index === next ? 0 : -1);
        this.tabs[next].focus();
      }, { signal });
      this.media.addEventListener('change', () => this.semantics(), { signal });
      this.semantics();
    }
    this.observer = new MutationObserver(() => this.dates());
    this.observer.observe(this, { subtree: true, attributes: true, attributeFilter: ['data-bs-uf-fecha', 'data-bs-uf-fuente'] });
    this.dates();
  }
  select(index) {
    this.index = index;
    this.style.setProperty('--bs-seg', String(index));
    this.tabs.forEach((tab, position) => {
      tab.setAttribute('aria-selected', String(position === index));
      tab.tabIndex = position === index ? 0 : -1;
    });
    this.panels.forEach((panel, position) => panel.toggleAttribute('data-bs-plan-activo', position === index));
  }
  semantics() {
    const mobile = this.media.matches;
    if (mobile) this.selector.setAttribute('role', 'tablist');
    else this.selector.removeAttribute('role');
    this.tabs.forEach((tab, index) => {
      if (mobile) tab.setAttribute('role', 'tab');
      else tab.removeAttribute('role');
      const panel = this.panels[index];
      if (mobile) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
      } else {
        panel.removeAttribute('role');
        panel.setAttribute('aria-labelledby', panel.querySelector('h3').id);
        panel.removeAttribute('tabindex');
      }
    });
  }
  dates() {
    this.panels.forEach(panel => {
      const price = panel.querySelector('[data-bs-precio]');
      const note = panel.querySelector('[data-bs-uf-nota]');
      if (!price || !note?.firstChild) return;
      const date = price.dataset.bsUfFecha;
      note.firstChild.nodeValue = price.dataset.bsUfFuente === 'mindicador' && /^\d{4}-\d{2}-\d{2}$/.test(date)
        ? `Referencial con la UF del ${date.split('-').reverse().join('/')}. Se factura en UF.`
        : 'Valor referencial aproximado. Se factura en UF.';
    });
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
  }
});
